import API, { APIWithoutURLBase } from './API';
import { API as APIService } from './API';

const path = `candidatos`;

const CandidatoService = {
    // FILTROS
    filters: async filters => await API.filters(path, filters),

    // EXPORTAR
    export: async filters => await API.export(path, filters),

    // LISTAR TODOS
    list: async () => await API.list(path),

    // LISTAR UM
    find: async id => await API.find(path, id),

    // BUSCAR NA PÁGINA PÚBLICA PARA INSCRIÇÃO
    buscarInscricao: async cpf => await API.find(`${path}/${cpf}/inscricao`, ''),
    buscarInscricaoFromEdition: async (edition, cpf) => await APIWithoutURLBase.find(`${process.env.REACT_APP_GATEWAY_URL}/olimpiada-professores-mirim-${edition}-services/${path}/${cpf}/inscricao`, ''),

    salvarDadosFatura: async (id, fatura) => await API.add(`${path}/${id}/pagamento/dados-fatura`, fatura),

    buscaUrlDePagamento: async id => await API.find(`${path}/${id}/pagamento/url-pagamento`, ''),
    buscaUrlDeDadosDoPagamento: async id => await API.find(`${path}/${id}/pagamento/url-dados-pagamento`, ''),

    atualizarEscolaMatricula: async (id, formData, config) => await APIService.post(`${path}/${id}/escola-atuacao`, formData, config),

    finalizarInscricao: async (id) => await API.add(`${path}/${id}/finalizar`, {}),

    reabrirInscricao: async (id) => await API.add(`${path}/${id}/reabrir-candidatura`, {}),

    // ATUALIZAR SENHA
    atualizarSenha: async (id, candidato) => await APIService.put(`${path}/${id}/senha`, candidato),

    // EDITAR
    edit: async (id, candidato) => await API.edit(path, id, candidato),

     // ESCOLHER MUNICÍPIO LOCAL PROVA
    escolherLocalProva: async (id, localProva) => await APIService.put(`${path}/${id}/local-prova`, localProva),

    // CONFIRMAR MUNICÍPIO LOCAL PROVA
    confirmarLocalProva: async (id, localProva) => await APIService.put(`${path}/${id}/local-prova/confirmar`, localProva),

    // CARREGAR PROVA DO CANDIDATO (RESULTADO/NOTA)
    carregarProva: async id => await APIService.get(`${path}/${id}/prova`),

    // ADICIONAR
    add: async candidato => await API.add(path, candidato),

    // REMOVER
    remove: async id => await API.remove(path, id),

    // LISTAR EMAILS
    listMails: async id => await APIService.get(`${path}/${id}/emails`),

    removerDocumento: async (id, documentoId) => await API.remove(`${path}/${id}/documentos`, documentoId),

    downloadDocumento: async (id, documentoId) => await API.download(`${path}/${id}/documentos`, `${documentoId}/download`),

    tratarDocumento: async (id, documentoId, tratamento) => await APIService.patch(`${path}/${id}/documentos/${documentoId}/realizar-tratamento`, tratamento)
}

export default CandidatoService;